import { Assets, Sprite, Container, TextStyle, Text, Graphics } from 'pixi.js';

import { Game as GinRummy } from 'gin-rummy-game-engine';

import Layouts from '../Scenes/Layouts.js'
import Cards from '../Sprites/Cards.js'
import Card from '../Sprites/Card.js'
import Button from '../Sprites/ButtonSolid.js'
import TurnIndicator from '../Sprites/TurnIndicator.js'
import HandIndicator from '../Sprites/HandIndicator.js'
import GameOver from '../Sprites/GameOver.js'
import RoundSummary from '../Sprites/RoundSummary.js'
import ChatBubble from '../Sprites/ChatBubble.js'
import PlayerScoreBoard from '../Sprites/PlayerScoreBoard.js'
import TurnTimer from '../Sprites/TurnTimer.js'
import Audio from '../Audio.js'


export default class GameScene {
    constructor(app, game, audio) {
        this.app = app || {};
        this.audio = audio;
        this.stageWidth = 500;
        this.stageHeight = 800;
        //this.loader = new PIXI.Loader();
        this.user = {};
        this.isLoaded = false;
        this.stage = new Container();
        this.ginRummy = null;
        this.tablePosition = 0;
        this.isChatMuted = false;
        this.isAudioMuted = this.app.isMuted;
        this.debug = false;
        this.isCreated = false;
        this.currentState = null;
        this.layouts = new Layouts();
        this.pileLayout = this.layouts.pileLayout0;

        //this.loadGame(game, this.tablePosition);
    }
    async preload(callback) {
        await this.create();
    }
    async create() {
        //required for facebook
        await Assets.init({
            preferences: {
                preferWorkers: false,
            }
        });

        //audio
        if (!this.audio) this.audio = new Audio()

        this.audio.load('CardClick', './assets/Audio/click_lower_volumn.wav');
        this.audio.load('PointSound', './assets/Audio/whoop.wav');
        this.audio.load('AchivementSound', './assets/Audio/chime.wav');
        this.audio.load('WinSound', './assets/Audio/win.wav');
        this.audio.load('Knocking', './assets/Audio/Knocking-on-door-two-knocks-www.fesliyanstudios.com.mp3');
        this.audio.load('Layoff', './assets/Audio/snap.wav');


        ////background
        //const textureBackground = await Assets.load('assets/Backgrounds/WoodBackground.png');
        // this.background = new Sprite(textureBackground);
        // this.background.name = "background";
        // this.background.width = this.stageWidth + 200;
        // this.background.height = this.stageHeight + 200;
        // this.background.x = -100;
        // this.background.y = -100;
        // this.background.zIndex = 0;
        // this.stage.addChild(this.background);

        //Safe Area
        let safeArea = new Graphics();
        //safeArea.lineStyle(4, 0xFFFF00, 1);
        safeArea.beginFill(0x000000);
        safeArea.drawRect(-20, 0, this.stageWidth + 40, this.stageHeight);
        safeArea.alpha = 0.2;
        this.stage.addChild(safeArea);

        //cards
        const deckSpriteSheet = await Assets.load('./assets/Decks/PixaromaDeck_SpriteSheet.json')
        const cards = this.CreateDeck();
        this.cardsUI = new Cards(cards, deckSpriteSheet);
        this.cardsUI.zIndex = 100;
        this.cardsUI.cardTouched = this.onCardTouched.bind(this);
        this.stage.addChild(this.cardsUI);


        //create text style
        var styleInstructions = new TextStyle({
            fontFamily: 'Arial',
            fontSize: 40,
            fill: '#FFFFFF',
            wordWrapWidth: 800,
            align: 'center'
        });

        // //Player scoreboard 0
        // this.player0Scoreboard = new PlayerScoreBoard("", "", 0xC03500);
        // this.player0Scoreboard.name = "profile0";
        // this.player0Scoreboard.zOrder = -80;
        // this.player0Scoreboard.interactive = true;
        // this.player0Scoreboard.on('pointerdown', this.player0Scoreboard_onClick.bind(this));
        // this.stage.addChild(this.player0Scoreboard);

        // //Player scoreboard 1
        // this.player1Scoreboard = new PlayerScoreBoard("", "", 0x479ACE);
        // this.player1Scoreboard.name = "profile1";
        // this.player1Scoreboard.zOrder = -80;
        // this.player1Scoreboard.interactive = true;
        // this.player1Scoreboard.on('pointerdown', this.player1Scoreboard_onClick.bind(this));
        // this.stage.addChild(this.player1Scoreboard);

        //pass button 0
        this.btnPass0 = new Button("Pass", 0x479ACE);
        this.btnPass0.name = "pass0";
        this.btnPass0.interactive = true;
        this.btnPass0.visible = false;
        this.btnPass0.zIndex = 200;
        this.btnPass0.on('pointerdown', this.btnPass_onClick.bind(this));
        this.stage.addChild(this.btnPass0);

        //pass button 1
        this.btnPass1 = new Button("Pass", 0x479ACE);
        this.btnPass1.name = "pass1";
        this.btnPass1.interactive = true;
        this.btnPass1.visible = false;
        this.btnPass1.zIndex = 200;
        this.btnPass1.on('pointerdown', this.btnPass_onClick.bind(this));
        this.stage.addChild(this.btnPass1);

        //knock button 1
        this.btnknock0 = new Button("knock", 0x479ACE);
        this.btnknock0.name = "knock0";
        this.btnknock0.interactive = true;
        this.btnknock0.visible = false;
        this.btnknock0.on('pointerdown', this.btnknock0_onClick.bind(this));
        this.stage.addChild(this.btnknock0);

        //knock button 2
        this.btnknock1 = new Button("knock", 0x479ACE);
        this.btnknock1.name = "knock1";
        this.btnknock1.interactive = true;
        this.btnknock1.visible = false;
        this.btnknock1.on('pointerdown', this.btnknock1_onClick.bind(this));
        this.stage.addChild(this.btnknock1);


        //endRound button 1
        this.btnNext = new Button("Next", 0x479ACE);
        this.btnNext.name = "btnNext";
        this.btnNext.interactive = true;
        this.btnNext.visible = false;
        this.btnNext.zIndex = 200;
        this.btnNext.on('pointerdown', this.btnNext_onClick.bind(this));
        this.stage.addChild(this.btnNext);


        //endRound button 1
        this.btnEndRound = new Button("Next", 0x479ACE);
        this.btnEndRound.name = "btnEndRound";
        this.btnEndRound.interactive = true;
        this.btnEndRound.visible = false;
        this.btnEndRound.zIndex = 200;
        this.btnEndRound.on('pointerdown', this.btnEndRound_onClick.bind(this));
        this.stage.addChild(this.btnEndRound);

        //btnStartGame button 1
        this.btnStartGame = new Button("Play Again", 0x479ACE);
        this.btnStartGame.name = "btnStartGame";
        this.btnStartGame.interactive = true;
        this.btnStartGame.visible = false;
        this.btnStartGame.zIndex = 200;
        this.btnStartGame.on('pointerdown', this.btnStartGame_onClick.bind(this));
        this.stage.addChild(this.btnStartGame);




        //instructions 0
        this.instructions0 = new Text('', styleInstructions);
        this.instructions0.name = "instructions0";
        this.instructions0.zIndex = 100;
        this.instructions0.scale.set(0.5);
        this.instructions0.anchor.set(0.5, 0);
        this.stage.addChild(this.instructions0);

        //instructions 1
        this.instructions1 = new Text('', styleInstructions);
        this.instructions1.name = "instructions1";
        this.instructions1.zIndex = 100;
        this.instructions1.scale.set(0.5);
        this.instructions1.anchor.set(0.5, 0);
        this.stage.addChild(this.instructions1);

        //chatBubble0 
        this.chatBubble0 = new ChatBubble('');
        this.chatBubble0.name = "chatBubble0";
        this.chatBubble0.zIndex = 210;
        this.stage.addChild(this.chatBubble0);

        //chatBubble1 
        this.chatBubble1 = new ChatBubble('');
        this.chatBubble1.name = "chatBubble1";
        this.chatBubble1.zIndex = 210;
        this.stage.addChild(this.chatBubble1);


        //KnockCount 0
        this.textDeadwoodCount0 = new Text('', styleInstructions);
        this.textDeadwoodCount0.name = "deadwoodCount0";
        this.textDeadwoodCount0.zIndex = 100;
        this.textDeadwoodCount0.scale.set(0.5);
        this.textDeadwoodCount0.anchor.set(0.5, 0);
        this.stage.addChild(this.textDeadwoodCount0);

        //KnockCount 1
        this.textDeadwoodCount1 = new Text('', styleInstructions);
        this.textDeadwoodCount1.name = "deadwoodCount1";
        this.textDeadwoodCount1.zIndex = 100;
        this.textDeadwoodCount1.scale.set(0.5);
        this.textDeadwoodCount1.anchor.set(0.5, 0);
        this.stage.addChild(this.textDeadwoodCount1);


        //ScoreCount 0
        this.textScoreCount0 = new Text('', styleInstructions);
        this.textScoreCount0.name = "scoreCount0";
        this.textScoreCount0.zIndex = 100;
        this.textScoreCount0.scale.set(0.5);
        this.textScoreCount0.anchor.set(0.5, 0);
        this.stage.addChild(this.textScoreCount0);

        //ScoreCount 1
        this.textScoreCount1 = new Text('', styleInstructions);
        this.textScoreCount1.name = "scoreCount1";
        this.textScoreCount1.zIndex = 100;
        this.textScoreCount1.scale.set(0.5);
        this.textScoreCount1.anchor.set(0.5, 0);
        this.stage.addChild(this.textScoreCount1);




        //stage 
        this.textStage = new Text('', styleInstructions);
        this.textStage.name = "stage";
        this.textStage.zIndex = 100;
        this.textStage.scale.set(0.5);
        this.textStage.anchor.set(0.5, 0);
        this.stage.addChild(this.textStage);

        //turnTimer1
        this.turnTimer1 = new TurnTimer();
        this.turnTimer1.name = "profile1";
        this.stage.addChild(this.turnTimer1);

        //turnTimer2
        this.turnTimer2 = new TurnTimer();
        this.turnTimer2.name = "profile2";
        this.stage.addChild(this.turnTimer2);

        //HandIndicator1
        this.handIndicator0 = new HandIndicator(0x479ACE);
        this.handIndicator0.name = "handIndicator0";
        this.handIndicator0.zIndex = 10;
        this.stage.addChild(this.handIndicator0);

        //HandIndicator2
        this.handIndicator1 = new HandIndicator(0xC03500);
        this.handIndicator1.name = "handIndicator1";
        this.handIndicator1.zIndex = 10;
        this.stage.addChild(this.handIndicator1);

        //drawIndicator0
        this.drawIndicator0 = new TurnIndicator(0x479ACE);
        this.drawIndicator0.name = "drawIndicator0";
        this.drawIndicator0.zIndex = 10;
        this.stage.addChild(this.drawIndicator0);

        //drawIndicator1
        this.drawIndicator1 = new TurnIndicator(0xC03500);
        this.drawIndicator1.name = "drawIndicator1";
        this.drawIndicator1.zIndex = 10;
        this.stage.addChild(this.drawIndicator1);

        //discardIndicator0
        this.discardIndicator0 = new TurnIndicator(0xC03500);
        this.discardIndicator0.name = "discardIndicator0";
        this.discardIndicator0.zIndex = 10;
        this.stage.addChild(this.discardIndicator0);

        //discardIndicator1
        this.discardIndicator1 = new TurnIndicator(0xC03500);
        this.discardIndicator1.name = "discardIndicator1";
        this.discardIndicator1.zIndex = 10;
        this.stage.addChild(this.discardIndicator1);

        //roundSummary
        this.roundSummary = new RoundSummary();
        this.roundSummary.name = "roundSummary";
        this.roundSummary.zIndex = 110;
        this.roundSummary.visible = true;
        this.roundSummary.onNext = this.btnNext_onClick.bind(this);
        this.stage.addChild(this.roundSummary);

        //gameOver
        this.gameOver = new GameOver();
        this.gameOver.name = "gameOver";
        this.gameOver.zIndex = 110;
        this.gameOver.visible = true;
        this.gameOver.onRematch = this.btnNext_onClick.bind(this);
        this.stage.addChild(this.gameOver);


        this.stage.children.sort(function (a, b) {
            return (a.zIndex || 0) - (b.zIndex || 0);
        });



        this.isLoaded = true;
        this.onStateChanged();
        //wait 1 second for the stage to load with await timeout(1000);
        //await new Promise(resolve => setTimeout(resolve, 3000));    



    }
    CreateDeck() {
        const deck = [];
        const Suits = ['S', 'C', 'D', 'H'];
        let pilez = 1;
        for (const suit of Suits) {
            for (let x = 1; x <= 13; ++x) {
                let rank;
                switch (x) {
                    case 1:
                        rank = 'A';
                        break;
                    case 11:
                        rank = 'J';
                        break;
                    case 12:
                        rank = 'Q';
                        break;
                    case 13:
                        rank = 'K';
                        break;
                    default:
                        rank = x;
                        break;
                }
                deck.push({
                    id: `${rank}${suit}`,
                    rank: rank,
                    suit: suit,
                    pile: 'draw',
                    pilez: pilez++
                });
            }
        }
        return deck;
    }
    transformCordinates(layouts, width, height) {
        //loop through each layout item
        for (const key in layouts) {
            const layout = layouts[key];
            //update x and y coordinates
            if (layout.xCenterOffset != null) {
                layout.x = width / 2 + layout.xCenterOffset;
            }
            if (layout.yCenterOffset != null) {
                layout.y = height / 2 + layout.yCenterOffset;
            }
            if (layout.left != null) {
                layout.x = layout.left;
            }
            if (layout.right != null) {
                layout.x = width - layout.right;
            }
            if (layout.top != null) {
                layout.y = layout.top;
            }
            if (layout.bottom != null) {
                layout.y = height - layout.bottom;
            }
            if (typeof layout.rotation !== "undefined" && layout.rotation == null) {
                layout.rotation = 0;
            }
            if (layout.widthPercent != null) {
                layout.width = width * layout.widthPercent / 100;
            }
            if (layout.heightPercent != null) {
                layout.height = height * layout.heightPercent / 100;
            }
        }
    }
    updateLayout(pileLayout) {
        if (!this.stage) return;
        this.transformCordinates(pileLayout, this.stageWidth, this.stageHeight);
        if (!this.stage.children) return;
        const uiElements = this.stage.children;
        for (let i = 0; i < uiElements.length; i++) {
            let uiElement = uiElements[i];
            let name = uiElement.name;
            if (name) {
                if (pileLayout[name]) {
                    //could dynamically set the properties here
                    if (pileLayout[name].x !== undefined) uiElement.x = pileLayout[name].x;
                    if (pileLayout[name].y !== undefined) uiElement.y = pileLayout[name].y;
                    if (pileLayout[name].width !== undefined) uiElement.width = pileLayout[name].width;
                    if (pileLayout[name].height !== undefined) uiElement.height = pileLayout[name].height;
                    if (pileLayout[name].zIndex !== undefined) uiElement.zIndex = pileLayout[name].zIndex;
                    if (pileLayout[name].visible !== undefined) uiElement.visible = pileLayout[name].visible;
                }
            }
        }

        this.stage.children.sort(function (a, b) {
            return (a.zIndex || 0) - (b.zIndex || 0);
        });

    }
    loadGame(ginRummy, user) {
        this.shutdown(); //added as it may not have shut down before
        this.user = user;
        if (this.ginRummy) {
            this.ginRummy.destroy();
        }
        if (ginRummy) {
            this.ginRummy = ginRummy;
        } else {
            console.log("Game not loaded");
            return;
        }

        this.ginRummy.debug = true;

        this.isChatMuted = this.ginRummy.isChatMuted;
        this.backgound = this.ginRummy.backgound;
        this.deck = this.ginRummy.deck;


        const game = this.ginRummy;
        const GameEvent = this.ginRummy.GameEvent();
        game.on(GameEvent.CardDiscarded, (data) => {
            this.isDirty = true;
            //console.log('card discarded', data);
        });

        game.on(GameEvent.CurrentPlayerChanged, (data) => {
            this.isDirty = true;
            //console.log('current player changed', data);
        });

        game.on(GameEvent.GameOver, (data) => {
            this.isDirty = true;
            //console.log('game over', data);
        });

        game.on(GameEvent.RoundEnded, (data) => {
            this.isDirty = true;
            //console.log('round ended', data);
        });

        game.on(GameEvent.RoundStageChanged, this.onStateChanged.bind(this));
        game.on(GameEvent.StateChanged, this.onStateChanged.bind(this));
        game.on(GameEvent.Passed, this.onStateChanged.bind(this));

        game.on(GameEvent.TookDiscard, (data) => {
            this.isDirty = true;
            //console.log('took discard', data);
        });

        game.on(GameEvent.TookTop, (data) => {
            this.isDirty = true;
            //console.log('took top', data);
        });
        game.on(GameEvent.CardMoved, this.onCardMoved.bind(this));
        game.on(GameEvent.InvalidAction, this.onInvalidAction.bind(this));
        game.on(GameEvent.PlayerChanged, this.onPlayerChanged.bind(this));


        //this.tablePosition = tablePosition;
        this.tablePosition = this.getTablePosition(game, user);



        this.pileLayout = this.getLayout(this.tablePosition, game.roundStage);

        if (this.isLoaded) {
            //this.updateLayout();
            this.onStateChanged();
        }
    }
    getTablePosition(game, user) {
        if (!game) game = this.ginRummy;
        if (!user) user = this.user || {};

        //todo: add getUserTablePosition from Game
        let tablePosition = game.gameState.players?.find(p => p.id === user.id)?.tablePosition;

        return tablePosition;
    }
    getLayout(tablePosition, stage) {
        if (tablePosition === 0 && stage === "knock") return this.layouts.pileLayout0_scoring;
        if (tablePosition === 0 && stage === "layoff") return this.layouts.pileLayout0_scoring;
        if (tablePosition === 0 && stage === "undercut") return this.layouts.pileLayout0_scoring;
        if (tablePosition === 0 && stage === "scoring") return this.layouts.pileLayout0_scoring;
        if (tablePosition === 0 && stage === "gameOver") return this.layouts.pileLayout0_scoring;
        if (tablePosition === 0) return this.layouts.pileLayout0;
        if (tablePosition === 1) return this.layouts.pileLayout1;
        if (tablePosition === "test") return this.layouts.pileLayout0;

        return this.layouts.pileLayout0;
    }
    update(force) {
        if(!this.isLoaded) return;

        if (this.cardsUI.hasCardMoved()) {
            this.playSound("CardClick");
        }

        let cIsDirty = this.cardsUI.update(force);
        if (cIsDirty)
            this.isDirty = true;
        else {
            // this.validateTweenEnd();
        }
    }

    render() {
        this.isDirty = false;
    }
    shutdown() {

    }
    playSound(id) {
        if (this.audio) {
            this.audio.play(id);
        }
    }
    onCardTouched(event) {
        let cardId = event.currentTarget.id;
        let pile = event.currentTarget.pile;
        let tablePosition = this.tablePosition;
        if (this.debug) {
            tablePosition = this.ginRummy.gameState.currentPlayer;
        }
        if (pile === "discard") {
            this.action("takeDiscard", { card: cardId }, tablePosition);
        }
        if (pile === "draw") {
            this.action("takeTop", { card: cardId }, tablePosition);
        }
        if (pile === "hand0") {
            this.action("discard", { card: cardId }, tablePosition);
        }
        if (pile === "hand1") {
            this.action("discard", { card: cardId }, tablePosition);
        }
        //todo: on crib state, stage/select the cards. play is playing to the crib
        // let state = this.ginRummy.currentState;
        // if (state === "crib") {
        //     this.action("select", cardId, this.tablePosition);
        // } else {
        //     this.action("play", cardId, this.tablePosition);
        // }
    }
    btnPass_onClick() {
        const currentPlayer = this.ginRummy.gameState.currentPlayer;
        this.action("pass", {}, currentPlayer);
    }
    btnknock0_onClick() {
        this.action("knock", {}, 0);
    }
    btnknock1_onClick() {
        this.action("knock", {}, 1);
    }
    btnEndRound_onClick() {
        const currentPlayer = this.ginRummy.gameState.currentPlayer;
        this.action("endRound", {}, currentPlayer);
    }
    btnStartGame_onClick() {
        const currentPlayer = this.ginRummy.gameState.currentPlayer;
        this.action("startGame", {}, currentPlayer);
    }

    btnNext_onClick() {
        const currentPlayer = this.ginRummy.gameState.currentPlayer;
        this.action("next", {}, currentPlayer);
    }
    player0Scoreboard_onClick() {

    }
    player1Scoreboard_onClick() {

    }
    action(command, data, position) {
        console.log("Command", { command, data, position })
        this.ginRummy.action(command, data, position);
    }
    //-----------game logic event---------------------------
    onStateChanged(data) {
        this.isDirty = true;
        //console.log('round state changed', data);
        if (this.ginRummy) {


            const roundStage = this.ginRummy.gameState.roundStage;
            const currentPlayer = this.ginRummy.gameState.currentPlayer;
            const tablePosition = this.tablePosition;
            const roundDetails = this.ginRummy.gameState.roundDetails;
            const gameState = this.ginRummy.gameState;
            const cards = this.ginRummy.gameState.cards;
            const players = this.ginRummy.gameState.players;

            this.pileLayout = this.getLayout(tablePosition, roundStage);
            const pileLayout = this.pileLayout;

            const isNewState = this.currentState !== roundStage;
            this.currentState = roundStage;

            if (this.isLoaded) {
                this.updateLayout(pileLayout);
                this.updateButtons(currentPlayer, roundStage);
                this.updateCards(cards);
                this.updateScore(players);
                this.updateDeadWood(cards);
                this.updateKnock(gameState);
                this.updateRoundSummay(roundDetails, roundStage == "scoring");
                this.updateGameOver(roundDetails.results || "Game Over", roundStage === "gameOver");


                // this.updateRoundSummay({
                //     results: "Player1 wins!",
                //     player1Name: "Player1",
                //     player2Name: "Computer",
                //     player1Deadwood: 5,
                //     player2Deadwood: -3,
                //     undercutPoints: 8,
                //     ginPoints: 7,
                //     totalPoints: 4,
                // }, true);
            }

            //play audio
            if (isNewState) {
                if (roundStage === "knock") { this.playSound("Knocking"); }
                if (roundStage === "layoff") this.playSound("Layoff");
                if (roundStage === "scoring") this.playSound("PointSound");
                if (roundStage === "gameOver") this.playSound("AchivementSound");
            }


        } else {
            const tablePosition = this.tablePosition;
            this.pileLayout = this.getLayout(tablePosition);
            const pileLayout = this.pileLayout;
            this.updateLayout(pileLayout);
        }

    }
    onCardMoved(data) {
        if (this.ginRummy) {
            if (this.isLoaded) {
                const cards = this.ginRummy.gameState.cards;
                this.isDirty = true;
                this.updateCards(cards);
            }
        }
        //console.log('cards moved', data);
    }
    onInvalidAction(command, data, position) {
        console.log('Invalid Action:', { command, data, position });
    }
    onPlayerChanged(data) {
        let game = this.ginRummy;
        let user = this.user || {};

        this.tablePosition = this.getTablePosition(game, user);
        this.pileLayout = this.getLayout(this.tablePosition, game.roundStage);

        this.onStateChanged();
    }
    //----------UI helpers-----------------------------------
    updateKnock(gameState) {
        if (!this.ginRummy) return;
        const ginRummy = this.ginRummy;

        const canPlay0 = ginRummy.Rules().can("knock", {}, 0, gameState);
        const canPlay1 = ginRummy.Rules().can("knock", {}, 1, gameState);

        this.btnknock0.visible = canPlay0;
        this.btnknock1.visible = canPlay1;

    }
    updateRoundSummay(roundDetails, show) {
        this.roundSummary.populate(roundDetails);
        this.roundSummary.visible = show;  //layout flow control may manage if it is shown or not

        this.isDirty = true;
    }
    updateGameOver(message, show) {
        this.gameOver.message = message;
        this.gameOver.update();
        this.gameOver.visible = show; //layout flow control may manage if it is shown or not

        this.isDirty = true;
    }
    updateDeadWood(cards) {
        if (!this.ginRummy) return;
        const ginRummy = this.ginRummy;

        const hand0 = ginRummy.getCardsInPile(cards, "hand0");
        let deadwood0 = ginRummy.countDeadwood(hand0);
        this.textDeadwoodCount0.text = "Deadwood: " + deadwood0;

        const hand1 = ginRummy.getCardsInPile(cards, "hand1");
        let deadwood1 = ginRummy.countDeadwood(hand1);
        this.textDeadwoodCount1.text = "Deadwood: " + deadwood1;
    }
    updateCards(cards) {
        if (!this.ginRummy) return;
        const ginRummy = this.ginRummy;
        const hand0 = this.sortByMeldsRankSuit(ginRummy.getCardsInPile(cards, "hand0"));
        const hand1 = this.sortByMeldsRankSuit(ginRummy.getCardsInPile(cards, "hand1"));
        const draw = ginRummy.getCardsInPile(cards, "draw");
        const discard = ginRummy.getCardsInPile(cards, "discard");

        //game logic should already set each card's pile
        this.updateCardPile(hand0, "hand0");
        this.updateCardPile(hand1, "hand1");
        this.updateCardPile(draw, "draw");
        this.updateCardPile(discard, "discard");

        const sortedCards = [].concat(hand0, hand1, draw, discard);

        this.cardsUI.updateCards(sortedCards, this.pileLayout);

    }

    updateCardPile(cards, pile) {
        for (const card of cards) {
            card.pile = pile;
        }
    }
    updateCardOrder(cards) {
        //update order
        for (let i = 0; i < cards.length; i++) {
            let card = cards[i];
            card.order = i;
        }
        return;
    }
    updateScore(players) {
        let player1Score = players[0]?.score || 0;
        let player2Score = players[1]?.score || 0;
        this.textScoreCount0.text = "Score: " + player1Score || 0;
        this.textScoreCount1.text = "Score: " + player2Score || 0;
    }
    updateButtons(playerTurn, roundStage) {
        if (!this.isLoaded) return;
        //clear old state
        this.handIndicator0.visible = false;
        this.handIndicator1.visible = false;
        this.drawIndicator0.visible = false;
        this.drawIndicator1.visible = false;
        this.discardIndicator0.visible = false;
        this.discardIndicator1.visible = false;
        this.btnPass0.visible = false;
        this.btnPass1.visible = false;
        this.btnknock1.visible = false;
        this.btnEndRound.visible = false;
        this.btnStartGame.visible = false;
        this.btnNext.visible = false;


        this.chatBubble0.show("");
        this.chatBubble1.show("");

        let messagePlayer0 = "";
        let messagePlayer1 = "";

        switch (roundStage) {
            case "preGame":
                this.btnNext.visible = true
                break;
            case "deal":
                break;
            case "firstCard":
                if (playerTurn === 0) {
                    this.discardIndicator0.visible = true;
                    this.btnPass0.visible = true;
                    messagePlayer0 = 'Pass or draw discard?';
                }
                if (playerTurn === 1) {
                    this.discardIndicator1.visible = true;
                    this.btnPass1.visible = true;
                    messagePlayer1 = 'Pass or draw discard?';
                }
                break;
            case "draw":
                if (playerTurn === 0) {
                    this.drawIndicator0.visible = true;
                    this.discardIndicator0.visible = true;
                    messagePlayer0 = 'Draw from deck or discard';
                }
                if (playerTurn === 1) {
                    this.drawIndicator1.visible = true;
                    this.discardIndicator1.visible = true;
                    messagePlayer1 = 'Draw from deck or discard';
                }
                break;
            case "discard":
                if (playerTurn === 0) {
                    this.handIndicator0.visible = true;
                    messagePlayer0 = 'Choose card to discard';
                }
                if (playerTurn === 1) {
                    this.handIndicator1.visible = true;
                    messagePlayer1 = 'Choose card to discard';
                }
                break;
            case "mustTakeTop":
                if (playerTurn === 0) {
                    this.drawIndicator0.visible = true;
                    messagePlayer0 = 'Draw from deck';
                }
                if (playerTurn === 1) {
                    this.drawIndicator1.visible = true;
                    messagePlayer1 = 'Draw from deck';
                }
                break;
            case "knock":
                const roundDetails = this.ginRummy.gameState.roundDetails;
                const whoKnocked = roundDetails.whoKnocked;
                const isBigGin = roundDetails.isBigGin;
                const isGin = roundDetails.isGin;
                const isKnocked = roundDetails.isKnocked;
                if (!isKnocked) break;

                let message = "Knock";
                if (isBigGin) { message = "BigGin!"; }
                if (isGin) { message = "Gin!"; }
                if (whoKnocked === 0) {
                    this.chatBubble0.show(message);
                }
                if (whoKnocked === 1) {
                    this.chatBubble1.show(message);
                }
                this.btnNext.visible = true;
                break;
            case "layoff":
                const roundDetails1 = this.ginRummy.gameState.roundDetails;
                this.btnNext.visible = true;
                const whoKnocked1 = roundDetails1.whoKnocked;
                if (whoKnocked1 !== 0) {
                    this.chatBubble0.show("Layoff");
                }
                if (whoKnocked1 !== 1) {
                    this.chatBubble1.show("Layoff");
                }
                break;
            case "undercut":
                const roundDetails2 = this.ginRummy.gameState.roundDetails;
                this.btnNext.visible = true;
                const whoKnocked2 = roundDetails2.whoKnocked;
                const wasUndercut = roundDetails2.wasUndercut;
                if (wasUndercut) {
                    if (whoKnocked2 !== 0) {
                        this.chatBubble0.show("Undercut");
                    }
                    if (whoKnocked2 !== 1) {
                        this.chatBubble1.show("Undercut");
                    }
                }
                break;
            case "scoring":
                break;
        }
        this.textStage.text = roundStage;
        this.instructions0.text = messagePlayer0;
        this.instructions1.text = messagePlayer1;

        this.isDirty = true;
    }
    sortByMeldsRankSuit(cards) {
        if (!this.ginRummy) return;
        const collection = this.ginRummy.getCollection(cards);

        let meld = 1;
        //id melds
        for (const set of collection.sets) {

            for (const card of set) {
                card.meld = meld;
            }
            meld += 1;
        }
        //id melds
        for (const run of collection.runs) {
            for (const card of run) {
                card.meld = meld;
            }
            meld += 1;
        }
        //id melds
        for (const card of collection.deadwood) {
            card.meld = null;
        }


        const sets = [].concat(...collection.sets);
        const runs = [].concat(...collection.runs);
        const deadwood = [].concat(...collection.deadwood);



        const sortedCards = [].concat(sets, runs, deadwood);

        this.updateCardOrder(sortedCards);
        return sortedCards;
    }
}